import React from 'react';
import DateParser from 'utils/date/DateParser';
import DateFormatter from 'utils/date/DateFormatter';
import { isChallengeBadge, isLimitedTimeBadge } from '../../../utils/BadgeUtils';
import Translate from 'components/Translate';

const BadgeAvailableDate = (props) => {
    const { badge } = props;

    if (!isLimitedTimeBadge(badge) || !isChallengeBadge(badge)) {
        const now = Date.now();
        const startDate = DateParser.parseISO(badge.badgeStartDate);
        const endDate = DateParser.parseISO(badge.badgeEndDate);

        if (!badge.badgeEndDate || endDate.getTime() > now) {
            return (
                <p className="badge-available-date">
                    <Translate
                        ns="badges"
                        content="available_since"
                        params={{ 0: DateFormatter.formatMonthDayYear(startDate) }}
                    />
                </p>
            );
        }
        const dateRange = DateFormatter.formatDateRange(startDate, endDate);
        return (
            <p className="badge-available-date">
                <Translate ns="badges" content="available_from" params={{ 0: dateRange }} />
            </p>
        );
    }

    return null;
};

export default BadgeAvailableDate;
